const TNLogger = {
    originalMethods: {},

    init() {
        // handle regular errors
        window.onerror = function(message, filePath, lineNumber, columnNumber, error) {
            TNLogger.logToServer('error', message, filePath, lineNumber, columnNumber, error && error.stack);
            return false;
        }

        const methods = ['warn', 'debug', 'log'];

        methods.forEach(method => {
            // Save the original console method
            this.originalMethods[method] = console[method];

            // Override the console method
            console[method] = (...args) => {
                const stack = new Error().stack;
                let parsedStack = this.parseStack(stack);

                // Inject custom logging code
                if (parsedStack != null) {
                    this.logToServer(method, args.join(' '), parsedStack.filePath, parsedStack.lineNumber, parsedStack.columnNumber, stack);
                }

                // Call the original console method
                this.originalMethods[method].apply(console, args);
            };
        });
    },

    logToServer(level, message, filePath, lineNumber, columnNumber, stack) {
        const data = new FormData();
        data.append('level', level);
        data.append('message', message);
        data.append('source', filePath);
        data.append('lineno', lineNumber);
        data.append('colno', columnNumber);
        data.append('stack', stack);

        // Use sendBeacon if available for better performance
        if ('sendBeacon' in navigator) {
            navigator.sendBeacon('/?page=javascript_report&ajax=true', data);
            return;
        }

        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/?page=javascript_report&ajax=true', true);
        xhr.send(data);
    },

    reset() {
        // Restore the original console methods
        Object.keys(this.originalMethods).forEach(method => {
            console[method] = this.originalMethods[method];
        });
    },

    parseStack(stack) {
        const chromeRegex = /^\s*at\s+(http[s]?:\/\/[^\s]+):(\d+):(\d+)$/;
        const firefoxRegex = /^.*?@(.*):(\d+):(\d+)$/;

        let parsedLine = null;
        let stackLines = stack.split('\n');

        let arrayLength = stackLines.length;
        for (let idx = 0; idx < arrayLength; idx++) {
            let line = stackLines[idx];
            let result = chromeRegex.exec(line) || firefoxRegex.exec(line);

            if (result == null || line.includes('tnlogger.js')) {
                continue;
            }

            parsedLine = {
                filePath: result[1],
                lineNumber: result[2],
                columnNumber: result[3]
            };

            break;
        }

        return parsedLine;
    }
};

// Initialize the Logger
TNLogger.init();